import Layout from "../../Layout";
import "./AboutMe.css";
import Portrait from "../../Images/portrait.jpg";
import { Link } from "react-router-dom";
import { useState } from "react";

import Beach from "../../Images/Beach.jpg";
import Club from "../../Images/Club.png";
import USARC from "../../Images/USARC.JPG";
import Comission from "../../Images/commissioning.jpeg";

// Tech icons
import { FaPython, FaJs, FaReact, FaGithub } from "react-icons/fa";
import { SiMysql, SiDotnet } from "react-icons/si";
import Figma from "../../Icons/Figma.svg";

//Art Skills
import Procreate from "../../Icons/Procreate.png";
import Photoshop from "../../Icons/Ps.svg";
import Illustrator from "../../Icons/Ai.svg";

//Other Skills
import { ReactComponent as CompassionIcon } from "../../Icons/Compassion.svg";
import { ReactComponent as Leadership } from "../../Icons/Leadership.svg";
import { ReactComponent as Time } from "../../Icons/Time.svg";
import { ReactComponent as Presentation } from "../../Icons/Presentation.svg";
import { ReactComponent as Stress } from "../../Icons/Stress.svg";
import { ReactComponent as Creativity } from "../../Icons/Creativity.svg";
import { ReactComponent as Problem } from "../../Icons/Problem.svg";

const AboutMe = () => {
  const [lightboxImg, setLightboxImg] = useState(null);

  const openLightbox = (src) => {
    setLightboxImg(src);
  };

  return (
    <Layout>
      <main className="about">
        <section className="hero" aria-labelledby="intro-heading">
          <div className="hero_text">
            <h1 id="intro-heading" className="hero_title">
              Im Sabrina - welcome to my personal ꙳repository꙳
            </h1>

            <div className="hero_mini_photo">
  <img src={Portrait} alt="Sabrina portrait small" />
</div>


            <h2 class="aboutme_title"><u>About Me:</u></h2>
            <p className="tl-dr">
              Im an aspiring UI/UX developer, digital artist, and programmer who
              also serves in the U.S. military. I am currently a freelance web
              and app developer and responsible for managing operations and
              logistics at my home station. I’m excited to use my creativity,
              technical skills, and leadership to contribute to work that
              matters.
            </p>
            
            <p className="hero_subtitle">
              
              I enlisted to give back to the country and to understand people
              better, because skill alone isn’t enough; real work also requires
              communication, patience, time management, and the ability to
              handle pressure. <b> Being great at your craft matters, but so does
              navigating last-minute deadlines, working with different
              personalities, and staying fortified when things get difficult. </b> 
            </p>

          
          </div>

          <figure className="hero_photo">
            <img src={Portrait} alt="Portrait of Sabrina" className="fade-up" />
          </figure>
        </section>

        <div className="section-divider">
          <hr />
          <span>↓↓↓ A little more about me ↓↓↓</span>
          <hr />
        </div>

        {/* --- Tech Skills -------------------------------------------------------- */}
        <section className="skills" aria-labelledby="skills-heading">
          <div className="skills_inner">
            <h2 id="skills-heading" className="skills_title">
              <u>My Tech Skills</u>
            </h2>

            <p className="skills_subtitle">
              I love creating clean, intuitive interfaces using JavaScript,
              React, and C#. I also enjoy working with large amounts of data
              through MySQL and Python. Additionally, I exercise my creativity
              and communicate my ideas through wireframing and high fidelity
              designs in Figma. Every project I tackle is crafted with care, and
              I’m proud of the balance I strike between my technical and
              creative skills. You can explore more of my work on GitHub or
              click the button below to view my technical projects.
            </p>

            <ul className="skills_icons" aria-label="Programming languages">
              <li className="skill_tile python">
                <FaPython />
              </li>
              <li className="skill_tile mysql">
                <SiMysql />
              </li>
              <li className="skill_tile js">
                <FaJs />
              </li>
              <li className="skill_tile react">
                <FaReact />
              </li>
              <li className="skill_tile dotnet">
                <SiDotnet />
              </li>
              <li className="skill_tile figma">
                <img src={Figma} alt="Figma" />
              </li>
              <li className="skill_tile github">
                <FaGithub />
              </li>
              <li className="skill_tile csharp-symbol"></li>
            </ul>

            <div className="skills_footer">
              <Link to="/cs" className="btn btn-primary">
                View my tech portfolio
              </Link>
            </div>
          </div>
        </section>

        {/* --- Art Skills -------------------------------------------------------- */}

        <section className="skills" aria-labelledby="skills-heading">
          <div className="skills_inner">
            <h2 id="skills-heading" className="skills_title">
              <u>My Art Skills</u>
            </h2>

            <p className="skills_subtitle">
              I use Procreate, Photoshop, Illustrator, and other Adobe products
              to create artwork that support my design and technical projects.
              Whether it’s creating UI concepts, a commission, or building
              consistent visuals for a brand or website, I focus on getting the
              job done through my passion for art. My art skills are a key part
              of who I am as a designer and developer.
            </p>

            <ul className="skills_icons art art-skills-icons">
              <li className="skill_tile procreate">
                <img src={Procreate} alt="Procreate" />
              </li>
              <li className="skill_tile photoshop">
                <img src={Photoshop} alt="Photoshop" />
              </li>
              <li className="skill_tile illustrator">
                <img src={Illustrator} alt="Illustrator" />
              </li>
            </ul>

            <div className="skills_footer">
              <Link to="/art" className="btn btn-primary">
                View my art portfolio
              </Link>
            </div>
          </div>
        </section>

        {/* --- Other Skills -------------------------------------------------------- */}

        <section className="skills" aria-labelledby="skills-heading">
          <div className="skills_inner">
            <h2 id="skills-heading" className="skills_title">
              <u>My Other Skills</u>
            </h2>

            <p className="skills_subtitle">
              My military experience, creativity, and technical expertise work
              together to shape how I solve problems and support the people
              around me. I lead with compassion, clear communication, and
              accountability, whether I’m guiding a team or working
              independently. I stay steady under stress, manage time well, and
              present ideas in a way that’s structured and easy to understand.
              This mix of leadership, critical thinking, and creativity allows
              me to stay calm, organized, and focused so that I can accomplish
              my tasks effectively.
            </p>
            <ul className="skills_icons" aria-label="Other skills icons">
              <li className="skill_tile compassion">
                <CompassionIcon />
              </li>
              <li className="skill_tile leadership">
                <Leadership />
              </li>
              <li className="skill_tile timemanagement">
                <Time />
              </li>

              <li className="skill_tile presentation">
                <Presentation />
              </li>
              <li className="skill_tile stress">
                <Stress />
              </li>
              <li className="skill_tile creativity">
                <Creativity />
              </li>
              <li className="skill_tile problem">
                <Problem />
              </li>
            </ul>
          </div>
        </section>

        {/* --- My Qualifications -------------------------------------------------------- */}
        <section className="skills" aria-labelledby="skills-heading">
          <div className="cert_list">
            <h2
              id="skills-heading"
              className="skills_title"
              style={{ paddingTop: "5rem" }}
            >
              <u>My Certifications & Qualifications</u>
            </h2>

            <p className="skills_subtitle">
              <span className="cert_item_title" style={{ paddingTop: "2rem" }}>
                DoD Security Clearance ● 2019
              </span>
              Active security clearence granted by the Department of Defense,
              allowing me to work on sensitive projects and handle classified
              information securely.
              <br />
              <br />
              <a
                className="cert_item_title cert_eo_link"
                href="https://www.linkedin.com/posts/sabrina-quadir_i-am-proud-to-have-successfully-completed-activity-7375943241927380992-kKeE?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAADHjKwAB7J-3pcyJKD9UrWUjsai3azq5JQs"
                target="_blank"
                rel="noopener noreferrer"
              >
                Equal Opportunity Training ● 2025 (click here to view more)
              </a>
              I earned my Equal Opportunity certification in Sloan, NV as an
              honor roll student recognized by USARC. This training strengthened
              my ability to work with people through empathy, work effectively
              with diverse teams, and conduct my work with grace in both
              independent and collaborative environments.
              <br />
              <br />
              <span className="cert_item_title">
                Google: Build Wireframes and Low-Fidelity Prototypes ● 2025
              </span>
              Developed skills in creating wireframes and low-fidelity
              prototypes.
              <br />
              <br />
              <span className="cert_item_title">
                Google: Conduct UX Research and Test Early Concepts ● 2025
              </span>
              Trained in gathering user insights, analyzing pain points, and
              validating design decisions through early testing to improve user
              experience.
              <br />
              <br />
              <span className="cert_item_title">
                Google: Start the UX Design Process — Empathize, Define, and
                Ideate ● 2025
              </span>
              Learned the fundamentals of UX processes that emphasize
              understanding user needs.
            </p>
          </div>
        </section>

        {/* --- My Core Values -------------------------------------------------------- */}

        <section className="skills" aria-labelledby="skills-heading">
          <div className="skills_inner">
            <h2
              id="skills-heading"
              className="skills_title"
              style={{ paddingTop: "5rem" }}
            >
              <u>My Core Values</u>
            </h2>

            <p className="skills_subtitle core_values_text">
              ✱ Keep faith <br />
              ✱ Practice makes perfect <br />
              ✱ Stay disciplined <br />
              ✱ Be kind <br />
              ✱ Don't be a robot <br />
            </p>
          </div>
        </section>

        {/* --- What can I offer? -------------------------------------------------------- */}

        <section
          className="skills what-can-i-do"
          aria-labelledby="skills-heading"
        >
          <div className="skills_inner">
            <h2
              id="skills-heading"
              className="skills_title"
              style={{ paddingTop: "1rem" }}
            >
              <u>What can I do for you?</u>
            </h2>

            <p className="impact">
              {" "}
              <b>
                I’ve always been someone who blends creativity with my technical
                skills, and I’ve spent years developing those strengths through
                passion and hands-on experience. The military became an
                important part of that journey, strengthing my ability to work
                with people and understand different perspectives, enhancing my
                work ethic, and teaching me how to stay composed through stress.
                What makes me stand out is how my technical, creative, and
                leadership strengths work together. I don’t stop at getting
                things done — I improve the work and help the team move forward.
                I’m committed to building solutions that are user-focused, bold,
                and functional.
              </b>
            </p>
          </div>
        </section>
        <div className="sq-divider" style={{ color: "#ff5a5f" }}></div>

        {/* --- Pictures of me -------------------------------------------------------- */}
        <section id="me-unfiltered" className="meu">
          <div className="meu_inner">
            <h2 className="meu_title">
              <u>Localhost: Me</u>
            </h2>
            <p className="meu_tagline">
              Small snapshots beyond work—leadership, service, and the things
              that keep me moving.
            </p>

            <div className="meu_grid">
              {/* Beach */}
              <figure className="meu_card">
                <div className="meu_img" onClick={() => openLightbox(Beach)}>
                  <img src={Beach} alt="Beach" />
                </div>
                <figcaption>
                  <h3 className="meu_card_title">Beach Day @ San Diego</h3>
                  <p className="meu_card_caption">
                    My first time in California - I was blown away by the view!
                  </p>
                </figcaption>
              </figure>

              {/* Club */}
              <figure className="meu_card">
                <div className="meu_img" onClick={() => openLightbox(Club)}>
                  <img src={Club} alt="Club event" />
                </div>
                <figcaption>
                  <h3 className="meu_card_title">
                    President of the Suffolk University Computer Science Club
                  </h3>
                  <p className="meu_card_caption">
                    Leading club members through workshops, projects, and
                    events.
                  </p>
                </figcaption>
              </figure>

              {/* USARC */}
              <figure className="meu_card">
                <div className="meu_img" onClick={() => openLightbox(USARC)}>
                  <img src={USARC} alt="USARC event" />
                </div>
                <figcaption>
                  <h3 className="meu_card_title">
                    Equal Opportunity Leader's Course{" "}
                  </h3>
                  <p className="meu_card_caption">
                    A group photo with the US Army Reserve Command and my fellow
                    classmates after completing EO training in Sloan, NV.
                  </p>
                </figcaption>
              </figure>

              {/* Commissioning */}
              <figure className="meu_card">
                <div
                  className="meu_img"
                  onClick={() => openLightbox(Comission)}
                >
                  <img src={Comission} alt="Commissioning ceremony" />
                </div>
                <figcaption>
                  <h3 className="meu_card_title">5 Years In The Making</h3>
                  <p className="meu_card_caption">
                    Since 2019, I've balanced college, military service, my
                    hobbies, and personal growth to reach this milestone. This
                    moment marked my commissioning as an officer in the United
                    States Army.
                  </p>
                </figcaption>
              </figure>
            </div>
          </div>

          {/* Lightbox */}
          {lightboxImg && (
            <div className="lightbox" onClick={() => setLightboxImg(null)}>
              {/* Close Button */}
              <button
                className="lightbox_close"
                onClick={() => setLightboxImg(null)}
                aria-label="Close"
              >
                ×
              </button>

              <img
                src={lightboxImg}
                alt="Expanded view"
                className="lightbox_img"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          )}
        </section>

        {/* --- Contact Card  -------------------------------------------------------- */}
        <section id="contact-card" className="contact_card">
          <div className="contact_outer">
            <h2 className="contact_title">Let’s Connect</h2>
            <p className="contact_subtitle">
              Feel free to reach out — I’d love to share more about my work or
              collaborate on new opportunities.
            </p>

            <div className="contact_box">
              <div className="contact_item">
                <i className="fa-solid fa-envelope contact_icon"></i>
                <a
                  href="mailto:qsabrina64@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>Email: </b>qsabrina64@gmail.com
                </a>
              </div>

              <div className="contact_item">
                <i className="fa-brands fa-github contact_icon"></i>
                <a
                  href="https://github.com/squadir10"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>GitHub: </b> squadir10
                </a>
              </div>

              <div className="contact_item">
                <i className="fa-brands fa-linkedin contact_icon"></i>
                <a
                  href="https://linkedin.com/in/sabrina-quadir"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                   <b>Linkedin.com/Sabrina-Quadir </b>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default AboutMe;
